package io.horion.auth.presentation.ui.components.common

import androidx.compose.runtime.*
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.icons.fa.FaMoon
import com.varabyte.kobweb.silk.components.icons.fa.FaSun
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.auth.presentation.ui.theme.AuthTheme
import org.jetbrains.compose.web.css.*

@Composable
fun ThemeToggleButton() {
    var colorMode by ColorMode.currentState
    val colors = AuthTheme.colors(colorMode)

    Box(
        modifier = Modifier
            .size(width = 35.px, height = 35.px)
            .display(DisplayStyle.Flex)
            .alignItems(AlignItems.Center)
            .justifyContent(JustifyContent.Center)
            .borderRadius(10.px)
            .cursor(Cursor.Pointer)
            .backgroundColor(colors.inputBg)
            .onClick { colorMode = colorMode.opposite },
        contentAlignment = Alignment.Center
    ) {
        if (colorMode.isLight) {
            FaMoon(modifier = Modifier.color(colors.primary))
        } else {
            FaSun(modifier = Modifier.color(colors.primary))
        }
    }
}